import React, { useEffect } from "react";
import useBreadcrumb from "../../hooks/useBreadcrumb";
import styles from './index.module.css';
import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
    TextField,
    MenuItem,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import CheckBoxIcon from "../../assets/icons/Bck/Group 18236.png";
import DoctorIllustration from "../../assets/images/doctor-illustration.png";

function Doctors() {
    const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();

    useEffect(() => {
        setBreadcrumb({
            title: "Doctors",
            links: [
                { title: "Home", url: "/" },
                { title: "Doctors", url: "/doctors" },
            ],
        });
        return clearBreadcrumb;
    }, []);

    return (
        <Box className={styles.content} sx={{ px: { xs: 2, md: 6 }, py: 6 }} >
            <Typography fontSize={"35px"} fontWeight={700} mb={1}>
                Become a Prescribing partner
            </Typography>

            <Typography fontSize={"16px"} color="text.secondary" mb={4}>
                Reduce administrative load, speed up approvals, and improve patient
                outcomes with our dedicated support team.
            </Typography>

            <Grid container columnSpacing={6} rowSpacing={0}>
                {/* LEFT CONTENT */}
                <Grid item xs={12} md={6}>
                    <Typography fontSize={"25px"} fontWeight={700} mb={2}>
                        SavCare Simplifies Pharmacy and Medical Prescriptions For Your Practice
                    </Typography>
                    <Stack spacing={1.5} mb={4}>
                        {[
                            "Seamless Onboarding",
                            "Easy ePrescribing + Prior Auth Support",
                            "Secure + Compliant Technology",
                            "Full-Service Patient Support",
                        ].map((text) => (
                            <Stack
                                direction="row"
                                spacing={1.5}
                                alignItems="center"
                                key={text}
                            >
                                <Box
                                    component="img"
                                    src={CheckBoxIcon}
                                    alt="Checked"
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        flexShrink: 0,
                                    }}
                                />
                                <Typography fontSize={"16px"} fontWeight={600} color="text.secondary">
                                    {text}
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>
                    <Typography fontSize={"25px"} fontWeight={700} mb={1}>
                        Focus on patient care, not paperwork.
                    </Typography>
                    <Typography fontSize={"25px"} fontWeight={700} mb={3}>
                        Start today.
                    </Typography>

                    <Box>
                        <img
                            src={DoctorIllustration}
                            alt="Doctors illustration"
                            style={{ width: "100%", maxWidth: 420 }}
                        />
                    </Box>
                </Grid>

                {/* RIGHT FORM */}
                <Grid item xs={12} md={6} sx={{
                    background: "#F2F6F7", p: 5, display: "flex",
                    alignItems: "stretch",
                }}>
                    <Box
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: "#fff",
                                borderRadius: 1,

                                "& fieldset": {
                                    borderColor: "#0a9a73",
                                },

                                "&:hover fieldset": {
                                    borderColor: "#088f68",
                                },

                                "&.Mui-focused fieldset": {
                                    borderColor: "#0a9a73",
                                    borderWidth: "2px",
                                },
                            },

                            "& .MuiInputLabel-root.Mui-focused": {
                                color: "#0a9a73",
                            },
                            width: "100%",
                        }}
                    >
                        <Stack spacing={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField label="First Name*" fullWidth size="small" />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField label="Last Name*" fullWidth size="small" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Phone Number*"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Email Address*"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Organization Name"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Address*"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField label="City*" fullWidth size="small" />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField label="State*" fullWidth size="small" />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField label="Zip Code*" fullWidth size="small" />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        label="Area of Interest*"
                                        fullWidth
                                        size="small"
                                    >
                                        <MenuItem value="cgm">CGM</MenuItem>
                                        <MenuItem value="mobility">Mobility</MenuItem>
                                        <MenuItem value="otherdme">Other DME</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                            <Stack direction={{ xs: "column", sm: "row" }}>
                                <Stack direction="row" sx={{ alignItems: "flex-start", mt: 2, ml: 1 }}>
                                    <Checkbox />
                                    <Typography variant="body1" color="text.secondary">
                                        By Checking this box, I agree that ADS may contact me regarding healthcare products and services via email and by telephone and/or
                                        text message utilizing automated technology at the telephone number(s) provided above. I understand this consent is not required to make a purchase.
                                    </Typography>
                                </Stack>
                            </Stack>
                            <Typography variant="body2" color="text.secondary" sx={{ pt: 1, pl: 2 }}>This site is protected by reCAPTCHA and the google privacy policy and terms of service apply.</Typography>

                            <Box sx={{ pl: 2 }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    sx={{ width: 130, fontSize: "19px" }}
                                >
                                    Submit →
                                </Button>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Doctors;